import React from "react";
import { Card } from "antd";
import Roadmap from "./roadmap/Roadmap";
import { BaseComponent } from "../../base/BaseComponent";
import ContactUsComponent from "../../contact-us/ContactUsComponent";

export default class InvestorZone extends BaseComponent {
  render() {
    const { InvestorsZone, InvestorZonePara } = this.lang;
    return (
      <div>
        <div>
          <h1 className="heading-big gx-text-center">{InvestorsZone}</h1>
          <p className="text-medium">{InvestorZonePara}</p>
        </div>
        <div>
          <ContactUsComponent
            params={{ title: this.lang.ContactUs }}
            {...this.props}
          />
        </div>
        <div>
          <Roadmap />
        </div>
      </div>
    );
  }
}
